// extracted by mini-css-extract-plugin
module.exports =  {"styledButton":"NewChatButton-module__styledButton--jGowM"};